// extracted by mini-css-extract-plugin
export default {"wrapper":"Step_wrapper__TsxP4","overlay":"Step_overlay__h5ip1","header":"Step_header__X9L50","body":"Step_body__trBoC","footer":"Step_footer__LzoqF"};